<div *ngIf="isQuickThemeSelectEnabled" id="kt_explore_toggle" class="d-flex align-items-center">
    <div [class]="customStyle">
        <i [class]="iconStyle"></i>
    </div>
</div>
